/**
 * Signals that item handling changed for a module (e.g. a service report), so
 * consumption pages can reload their item lists without polling.
 *
 * - Other tabs are notified through localStorage (`storage` event).
 * - The current tab is notified through a window event, since `storage`
 *   never fires in the tab that wrote the value.
 */
export const ITEM_HANDLING_UPDATED_EVENT = "promang:item-handling-updated";

export const itemHandlingUpdateKey = (moduleParam) => `item_handling_update_${moduleParam}`;

export function markItemHandlingUpdated(moduleParam) {
  if (!moduleParam) return;
  const key = itemHandlingUpdateKey(moduleParam);
  try {
    localStorage.setItem(key, Date.now().toString());
  } catch {
    /* storage unavailable (private mode / quota): the same-tab event still fires */
  }
  window.dispatchEvent(new CustomEvent(ITEM_HANDLING_UPDATED_EVENT, { detail: { key } }));
}
